import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EmployeeImportRow } from '../models/employee-import-row.model';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface CurrentUser {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  roles: { id: number; name: string }[];
  jobTitleRoles: any[];
  departmentRoles: any[];
  jobTitle: string | null;
  reportTo: string | null;
}

@Injectable({ providedIn: 'root' })
export class EmployeeUploadService {
  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) { }

  /** Upload multiple employee rows */
  uploadRows(rows: EmployeeImportRow[]) {
    const payload = rows.map((r) => this.mapRowToApi(r));

    console.log('Employee upload request payload:', payload);
    console.log('Employee upload request payload JSON:', JSON.stringify(payload, null, 2));

    return this.http.post(`${this.baseUrl}/api/users/multiple`, payload);
  }

  /** Get the currently logged-in user */
  getCurrentUser(): Observable<CurrentUser> {
    return this.http.get<CurrentUser>(`${this.baseUrl}/api/account/get-current-user`);
  }

  /** Map the row to API shape */
  private mapRowToApi(row: EmployeeImportRow) {
    return {
      EmployeeNumber: String(row.EmployeeNumber),
      FirstName: row.FirstName,
      MiddleInitial: row.MiddleInitial ?? null,
      LastName: row.LastName,
      HireDate: this.normalizeDate(row.HireDate),
      EmploymentStatus: row.EmploymentStatus,
      Rfid: row.Rfid ? String(row.Rfid) : '',
      Department: Number(row.Department),
      DefaultWorkOrderNumber: String(row.DefaultWorkOrderNumber),
      CompanyName: row.CompanyName,
      PayGroup: row.PayGroup,
      OvertimeThreshold: row.OvertimeThreshold ?? null,
      Shift: row.Shift,
      ScheduledHours: row.ScheduledHours,
      ScheduledDays: row.ScheduledDays,
      timezoneId: 'America/New_York',
      AccrualName: row.AccrualName ?? null,
      WorkerType: row.WorkerType,
      SupervisorNumber: row.SupervisorNumber ? String(row.SupervisorNumber).trim() : '',
      Email: row.Email != null ? String(row.Email).trim() : null,
      PhoneNumber: this.normalizePhoneNumber(row.PhoneNumber),
    };
  }

  /** Normalize date for API */
  private normalizeDate(value: any): string {
    if (!value) return '';

    if (typeof value === 'string') {
      return value.split('T')[0];
    }

    if (typeof value === 'number') {
      const date = new Date(Math.round((value - 25569) * 86400 * 1000));
      return date.toISOString().split('T')[0];
    }

    if (value instanceof Date) {
      return value.toISOString().split('T')[0];
    }

    return String(value);
  }

  private normalizePhoneNumber(value: string | number | null | undefined): string | null {
    if (value == null) return null;

    const digitsOnly = String(value).replace(/\D/g, '');
    if (!digitsOnly) return null;

    if (digitsOnly.length === 10) {
      return `1${digitsOnly}`;
    }

    return digitsOnly;
  }
}